import Wrapper from "../../layout/Wrapper";
import CommissionDetailPage from "../../screens/comission/CommissionDetailPage";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
	title: "CommissionDetailPage",
	description: "",
};
	
export default function CommissionDetailPageRoute() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CommissionDetailPage />
		</Wrapper>
	);
}